var LocationService = (function () {

	function service() {

		this.shippingCountries = [
			{'code': 'AX','name':'Aland Islands'},
            {'code': 'AL','name':'Albania'},
            {'code': 'AD','name':'Andorra'},
            {'code': 'AM','name':'Armenia'},
            {'code': 'AU','name':'Australia'},
            {'code': 'AT','name':'Austria'},
            {'code': 'AZ','name':'Azerbaijan'},
            {'code': 'BH','name':'Bahrain'},
            {'code': 'BY','name':'Belarus'},
            {'code': 'BE','name':'Belgium'},
            {'code': 'BA','name':'Bosnia And Herzegovina'},
            {'code': 'BV','name':'Bouvet Island'},
            {'code': 'BG','name':'Bulgaria'},
            {'code': 'CA','name':'Canada'},
            {'code': 'CN','name':'China'},
            {'code': 'HR','name':'Croatia'},
            {'code': 'CY','name':'Cyprus'},
            {'code': 'CZ','name':'Czech Republic'},
            {'code': 'DK','name':'Denmark'},
            {'code': 'EG','name':'Egypt'},
            {'code': 'EE','name':'Estonia'},
            {'code': 'EE','name':'Estonia'},
            {'code': 'FO','name':'Faroe Islands'},
            {'code': 'FI','name':'Finland'},
            {'code': 'FR','name':'France'},
            {'code': 'GE','name':'Georgia'},
            {'code': 'DE','name':'Germany'},
            {'code': 'GI','name':'Gibraltar'},
            {'code': 'GR','name':'Greece'},
            {'code': 'GL','name':'Greenland'},
            {'code': 'GP','name':'Guadeloupe'},
            {'code': 'GG','name':'Guernsey'},
            {'code': 'VA','name':'Holy See'},
            {'code': 'HK','name':'Hong Kong'},
            {'code': 'HU','name':'Hungary'},
            {'code': 'IS','name':'Iceland'},
            {'code': 'IN','name':'India'},
            {'code': 'ID','name':'Indonesia'},
            {'code': 'IQ','name':'Iraq'},
            {'code': 'IE','name':'Ireland'},
            {'code': 'IM','name':'Isle Of Man'},
            {'code': 'IL','name':'Israel'},
            {'code': 'IT','name':'Italy'},
            {'code': 'JP','name':'Japan'},
            {'code': 'JE','name':'Jersey'},
            {'code': 'JO','name':'Jordan'},
            {'code': 'KZ','name':'Kazakhstan'},
            {'code': 'XK','name':'Kosovo'},
            {'code': 'KW','name':'Kuwait'},
            {'code': 'LV','name':'Latvia'},
            {'code': 'LB','name':'Lebanon'},
            {'code': 'LI','name':'Liechtenstein'},
            {'code': 'LT','name':'Lithuania'},
            {'code': 'LU','name':'Luxembourg'},
            {'code': 'MY','name':'Malaysia'},
            {'code': 'MT','name':'Malta'},
            {'code': 'MX','name':'Mexico'},
            {'code': 'MD','name':'Moldova'},
            {'code': 'MC','name':'Monaco'},
            {'code': 'ME','name':'Montenegro'},
            {'code': 'NL','name':'Netherlands'},
            {'code': 'NZ','name':'New Zealand'},
            {'code': 'MK','name':'North Macedonia'},
            {'code': 'NO','name':'Norway'},
            {'code': 'OM','name':'Oman'},
            {'code': 'PH','name':'Phillippines'},
            {'code': 'PL','name':'Poland'},
            {'code': 'PT','name':'Portugal'},
            {'code': 'QA','name':'Qatar'},
            {'code': 'RE','name':'Reunion'},
            {'code': 'RO','name':'Romania'},
            {'code': 'RU','name':'Russia'},
            {'code': 'SM','name':'San Marino'},
            {'code': 'SA','name':'Saudi Arabia'},
            {'code': 'RS','name':'Serbia'},
            {'code': 'SG','name':'Singapore'},
            {'code': 'SK','name':'Slovakia'},
            {'code': 'SI','name':'Slovenia'},
            {'code': 'KR','name':'South Korea'},
            {'code': 'ES','name':'Spain'},
            {'code': 'SJ','name':'Svalbard And Jan Mayen'},
            {'code': 'SE','name':'Sweden'},
            {'code': 'CH','name':'Switzerland'},
            {'code': 'TW','name':'Taiwan'},
            {'code': 'TH','name':'Thailand'},
            {'code': 'TR','name':'Turkey'},
            {'code': 'UA','name':'Ukraine'},
            {'code': 'AE','name':'United Arab Emirates'},
            {'code': 'GB','name':'United Kingdom'},
            {'code': 'US','name':'United States'},
            {'code': 'VN','name':'Vietnam'},
            {'code': 'YE','name':'Yemen'}
		];

      	// 2020 redesign
        this.regions = {
          "america": {
            "text": "North America",
            "countries": ["US", "CA", "MX"]
          },
          "australia": {
            "text": "Au & NZ",
            "countries": ["AU","NZ"]
          },
          "asia": {
            "text": "Asia",
            "countries": ["CN","HK","IN","ID","JP","MY","PH","SG","KR","TW","TH","VN"]
          },
          "europe": {
            "text": "Europe",
            "countries": ["AX","AL","AD","AM","AT","AZ","BY","BE","BA","BV","BG","HR","CY","CZ","DK","EE","EE","FO","FI","FR","GE","DE","GI","GR","GL","GP","GG","VA","HU","IS","IE","IM","IT","JE","KZ","XK","LV","LI","LT","LU","MT","MD","MC","ME","NL","MK","NO","PL","PT","RE","RO","RU","SM","RS","SK","SI","ES","SJ","SE","CH","TR","UA","GB"]
          },
          "middle-east": {
            "text": "Middle East",
            "countries": ["BH","EG","IQ","IL","JO","KW","LB","OM","QA","SA","AE","YE"]
          }
        };
      
        // this currency
        this.currencyRules = [
          {
            "currency": "AUD", 
            "countries": ["AU"].concat(this.regions["asia"].countries)
          },
          {
            "currency": "NZD", 
            "countries": ["NZ"]
          },
          {
            "currency": "EUR", 
            "countries": [].concat(this.regions["europe"].countries)
          }
        ];
      
		this.redirectRules = [
      {
				"domain": "www.sommerswim.com.au", 
				"default": "AU",
				"countries": this.regions["australia"].countries.concat(this.regions["asia"].countries)
			},
			{
				"domain": "www.sommerswim.eu",
                // "domain": "sommereu.myshopify.com",
				"default": "GB",
                "countries": this.regions["europe"].countries
			},
			{
				"domain": "www.sommerswim.com",
				"default": "US",
				"countries": this.regions["middle-east"].countries
                    .concat(this.regions["america"].countries)
			}


            // // TODO: temporary, for testing, local host as AU, and sommerswimcom.myshopify.com as US
            // // {
            // // 	"domain": "127.0.0.1",
            // // 	"default": "US",
            // // 	"countries": this.regions["europe"].countries
            // //               .concat(this.regions["middle-east"].countries)
            // //               .concat(this.regions["america"].countries)
            // // },
            // {
            //   "domain": "127.0.0.1", 
            //   "default": "AU",
            //   "countries": this.regions["australia"].countries.concat(this.regions["asia"].countries)
            // },
            // {
            //   "domain": "sommerswimcom.myshopify.com",
            //   "default": "US",
            //   "countries": this.regions["middle-east"].countries
            //               .concat(this.regions["america"].countries)
            // },
            // {
            //   "domain": "sommereu.myshopify.com",
            //   "default": "GB",
            //   "countries": this.regions["europe"].countries
            // }

		]

        //console.log('DEBUG, redirect rules', this.redirectRules);
	}

	service.prototype = {
		getDefaultCountry: function(domain){
			var rule = this.redirectRules.find(function(o) {
				return o.domain === domain;
			});
			var country = this.shippingCountries.find(function(o){
				return o.code === rule.default;
			});

			return {
				domain: rule.domain,
				country: country
			}
		},
      	// 2020 redesign
        getRegion: function (countryCode) {
          var regionKey;
          var regiontext = '';
          for (regionKey in this.regions) {
            if (this.regions.hasOwnProperty(regionKey)) {
              if (this.regions[regionKey].countries.find(function(code) {
                  return code === countryCode;
              })) {
              	return this.regions[regionKey].text; 
              }
            }
          }
          return undefined;
        },      
		evaluteRules: function (countryCode) {

			var result = {
				domain: "www.sommerswim.com",
				country: {
                    "code": "US",
                    "name": "USA"
                }
			}

			var country = this.shippingCountries.find(function(o) {
				return o.code === countryCode;
			});

			if(country){
				var rule = this.redirectRules.find(function(o){
					return o.countries.includes(country.code);
				});
				if(rule){
					result = {
						domain: rule.domain,
						country: country
					};
				}
			}

			return result;
		},

    evaluateCurrencyRules: function (countryCode) {
      var result = 'USD';

			var country = this.shippingCountries.find(function(o) {
				return o.code === countryCode;
			});

			if(country){
				var rule = this.currencyRules.find(function(o){
					return o.countries.includes(country.code);
				});
        if(rule){
					result = rule.currency;
				}

			}

			return result;

		}
	};

	return service;

})();